import { createSettingsParams, SettingsParamType } from '@wix/tpa-settings';

import {
  ADD_TO_CART_BUTTON_PLACEMENT,
  HEADER_PLACEMENT,
  ITEM_IMAGE_PLACEMENT,
  ITEM_IMAGE_RATIO,
  ITEM_IMAGE_RESIZE,
  ITEM_LAYOUT_TYPE,
} from '../../../constants';

export type LayoutSettingsParams = {
  itemLayoutType: SettingsParamType.Number;
  itemImagePlacement: SettingsParamType.Number;
  itemImageRatio: SettingsParamType.Number;
  itemImageResize: SettingsParamType.Number;
  headerImagePlacement: SettingsParamType.Number;
  addToCartButtonPlacement: SettingsParamType.Number;
};

// Declared inline (not via `layoutSettingsParams.itemLayoutType`) because
// `itemImageRatio` needs it inside the same `createSettingsParams` call, and
// referencing the exported const in its own initializer makes it implicitly
// `any` for TypeScript. `key` must stay in sync with the object key below.
const itemLayoutTypeParam = {
  key: 'itemLayoutType',
  type: SettingsParamType.Number,
  getDefaultValue: () => ITEM_LAYOUT_TYPE.STRIP,
};

export const layoutSettingsParams = createSettingsParams<LayoutSettingsParams>({
  itemLayoutType: {
    type: SettingsParamType.Number,
    getDefaultValue: () => ITEM_LAYOUT_TYPE.STRIP,
  },
  itemImagePlacement: {
    type: SettingsParamType.Number,
    getDefaultValue: () => ITEM_IMAGE_PLACEMENT.RIGHT,
  },
  itemImageRatio: {
    type: SettingsParamType.Number,
    // No stored value means the site predates the Image ratio control, so fall
    // back to the shape it already rendered: strip 1:1, card 16:9. This is what
    // keeps existing card sites off 1:1 — the viewer reads these settings
    // ungated, so a flat SQUARE default would reflow every card site on deploy.
    getDefaultValue: ({ getSettingParamValue }) =>
      getSettingParamValue(itemLayoutTypeParam) === ITEM_LAYOUT_TYPE.CARD
        ? ITEM_IMAGE_RATIO.WIDE
        : ITEM_IMAGE_RATIO.SQUARE,
  },
  itemImageResize: {
    type: SettingsParamType.Number,
    getDefaultValue: () => ITEM_IMAGE_RESIZE.CROP,
  },
  headerImagePlacement: {
    type: SettingsParamType.Number,
    getDefaultValue: () => HEADER_PLACEMENT.BELOW,
  },
  addToCartButtonPlacement: {
    type: SettingsParamType.Number,
    getDefaultValue: () => ADD_TO_CART_BUTTON_PLACEMENT.ITEM_INFO,
  },
});
